/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ desc: NonNullable<unknown> }} Openquestionschatprefill3Inputs */

const en_openquestionschatprefill3 = /** @type {(inputs: Openquestionschatprefill3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About this open question: ${i?.desc} — walk me through it.`)
};

const pt_openquestionschatprefill3 = /** @type {(inputs: Openquestionschatprefill3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sobre este ponto: ${i?.desc} — explica-me.`)
};

/**
* | output |
* | --- |
* | "About this open question: {desc} — walk me through it." |
*
* @param {Openquestionschatprefill3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionschatprefill3 = /** @type {((inputs: Openquestionschatprefill3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionschatprefill3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionschatprefill3(inputs)
	return pt_openquestionschatprefill3(inputs)
});
export { openquestionschatprefill3 as "openQuestionsChatPrefill" }